import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import RecipeActions from '../components/RecipeActions';
import './Recipe.css';

const baseURL = process.env.REACT_APP_API_URL;

function RecipePage() {
    const { id } = useParams();
    const [recipe, setRecipe] = useState(null);
    const [loading, setLoading] = useState(true);
    const [checkedIngredients, setCheckedIngredients] = useState([]);
    const [checkedSteps, setCheckedSteps] = useState([]);

    useEffect(() => {
        const fetchRecipe = async () => {
            try {
                const res = await fetch(`${baseURL}/recipes/${id}`);
                if (!res.ok) throw new Error("Recipe not found");
                const data = await res.json();
                setRecipe(data);
            } catch (err) {
                console.error("Error fetching recipe:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchRecipe();
    }, [id]);

    const toggleIngredient = (index) => {
        setCheckedIngredients((prev) =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    const toggleStep = (index) => {
        setCheckedSteps((prev) =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    if (loading) return <div className="recipe-page">Loading...</div>;
    if (!recipe) return <div className="recipe-page">Recipe not found</div>;

    return (
        <>
            <Header />
            <div className="recipe-page">
                <h1 className="recipe-title">{recipe.title}</h1>
                <p className="recipe-meta">
                    by <strong><Link to={`/user/${recipe.author}`} className="author-link">{recipe.author}</Link></strong> · {new Date(recipe.createdAt).toLocaleDateString()}
                </p>
                <img
                    src={`${baseURL}/uploads/${recipe.image}`}
                    alt={recipe.title}
                    className="recipe-image"
                />

                <h2 className="ingredients-section-header">Ingredients</h2>
                <ul className="ingredient-list">
                    {recipe.ingredients.map((item, idx) => (
                        <li
                            key={idx}
                            onClick={() => toggleIngredient(idx)}
                            className={checkedIngredients.includes(idx) ? 'crossed-out' : ''}
                        >
                            {item}
                        </li>
                    ))}
                </ul>
                <p style={{ marginTop: '10px', fontWeight: 'bold' }}>
                    {recipe.calories !== null
                        ? `Total Calories: ${recipe.calories} kcal`
                        : 'Total Calories: Not calculated'}
                </p>

                <h2 className="steps-section-header">Steps</h2>
                <ol className="step-list">
                    {recipe.steps.map((step, idx) => (
                        <li
                            key={idx}
                            onClick={() => toggleStep(idx)}
                            className={checkedSteps.includes(idx) ? 'crossed-out' : ''}
                        >
                            {step}
                        </li>
                    ))}
                </ol>

                <div className="actions">
                    <RecipeActions
                        recipeId={recipe._id}
                        initialLikes={recipe.likes}
                        likedUsers={recipe.likedUsers}
                    />
                </div>
            </div>
        </>
    );
}

export default RecipePage;
